<template>
  <div class="conntiner pt16 pb16 pl24 pr24">
    <div class="searchBox">
      <a-space direction="vertical" v-if="false">
        <a-range-picker v-model:value="value3" @change="onChange">
          <template #suffixIcon>
            <SmileOutlined />
          </template>
        </a-range-picker>
      </a-space>

      <a-space class="mr-10">
        <a-input
          class="keyword"
          allowClear
          v-model:value="pageData.search_key"
          @pressEnter="changePage"
          :placeholder="t('algorithm.keywordPlaceholder')"
        />
      </a-space>
      <a-space class="mr-10">
        <a-select
          ref="select"
          style="width: 96px"
          allowClear
          v-model:value="pageData.marker_status"
          @change="changePage"
          :placeholder="t('algorithm.alarmTypePlaceholder')"
        >
          <a-select-option :value="1">{{ t('algorithm.normal') }}</a-select-option>
          <a-select-option :value="0">{{ t('algorithm.falseAlarm') }}</a-select-option>
          <!-- <a-select-option  v-for="item in modelList" :key="item.modelNo" :value="item.modelNo">{{item.name}}</a-select-option> -->
        </a-select>
      </a-space>
      <a-space class="mr-10">
        <a-range-picker
          :show-time="{ format: 'HH:mm:ss' }"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="x"
          :placeholder="[t('algorithm.startTimePlaceholder'), t('algorithm.endTimePlaceholder')]"
          v-model:value="pageData.times"
        />
      </a-space>
      <a-button type="default" @click="changePage">{{ t('algorithm.query') }}</a-button>
      <a-radio-group v-model:value="viewMode" class="search-view-switch" button-style="solid">
        <a-radio-button value="table">{{ t('algorithm.table') }}</a-radio-button>
        <a-radio-button value="card">{{ t('algorithm.card') }}</a-radio-button>
      </a-radio-group>
    </div>

    <div class="tablebox">
      <!-- <div class="mb10">
            <a-button danger size="small" @click="()=>onSign()" :disabled="!selectedRowKeys.length">批量标记</a-button>
          </div> -->
      <div class="list-body">
      <a-spin
        v-if="viewMode === 'card'"
        :spinning="listLoading"
        :tip="t('common.loading')"
        size="large"
        wrapper-class-name="alarm-card-spin"
      >
      <div class="task-card-grid">
        <div v-for="record in dataList" :key="record.id" class="task-card">
          <div class="task-info">
            <p class="task-meta-row">
              <span class="task-meta-label">{{ t('algorithm.alarmTypeLabel') }}</span>
              <span class="task-meta-value">{{ record.modelName || '--' }}</span>
            </p>
            <p class="task-meta-row">
              <span class="task-meta-label">{{ t('algorithm.alarmTimeLabel') }}</span>
              <span class="task-meta-value">{{ record.alarmDate || '--' }}</span>
            </p>
            <p class="task-meta-row">
              <span class="task-meta-label">{{ t('algorithm.alarmImageLabel') }}</span>
            </p>
            <div class="alarm-image-wrap" @click="openImages(record)">
              <img class="alarm-image" :src="record.alarmImage" :alt="t('algorithm.alarmImage')" />
            </div>
          </div>
        </div>
        <a-empty
          v-if="!listLoading && dataList.length === 0"
          :description="t('algorithm.noAlarmData')"
          class="empty-state"
        />
      </div>
      </a-spin>

      <div v-else class="table-scroll">
        <a-table
          row-key="id"
          :data-source="dataList"
          align="center"
          :pagination="false"
          :loading="listLoading"
          :scroll="{ x: '100%', y: tableScrollY }"
        >
          <a-table-column align="center" key="modelName" :title="t('algorithm.alarmType')" data-index="modelName" />
          <a-table-column align="center" key="alarmDate" :title="t('algorithm.alarmTime')" data-index="alarmDate" />
          <a-table-column
            :customCell="setCellStyle"
            align="center"
            key="alarmImage"
            :title="t('algorithm.alarmImage')"
            data-index="alarmImage"
          >
            <template #default="{ record }">
              <img :src="record.alarmImage" style="width: 30px; height: 30px" @click="openImages(record)" alt="" />
            </template>
          </a-table-column>
          <a-table-column align="center" :title="t('algorithm.alarmVideo')" v-if="false">
            <template #default="{ record }">
              <span style="color: var(--uav-primary)" @click="playVideo(record)">
                <VideoCameraOutlined />
              </span>
            </template>
          </a-table-column>
          <a-table-column key="action" :title="t('algorithm.operation')">
            <template #default="{ record }">
              ---
              <!-- <a-button type="primary" size="small" @click="handleMark(record)">标记</a-button>
                          <a-button :class="{'ml10':true,flying:record.id === alarmId }" :loading="rowLoading[record.id]" size="small" :disabled="!!alarmId" @click="flyTo(record)">{{record.id === alarmId?'正在执行':'飞往此处'}}</a-button> -->
            </template>
          </a-table-column>
        </a-table>
      </div>
      </div>

      <div class="pagination-wrapper" v-if="paginationProp.total > 0">
        <a-pagination
          :current="paginationProp.current"
          :page-size="pageData.page_size"
          :total="paginationProp.total"
          :disabled="listLoading"
          :show-size-changer="true"
          :show-quick-jumper="true"
          :page-size-options="['20', '50', '100']"
          @change="handlePageChange"
          @showSizeChange="handlePageChange"
        />
      </div>
    </div>

    <div class="vediobox" v-if="videoShow">
      <div class="title">
        <span>{{ t('algorithm.alarmVideoTitle') }}</span>
        <img
          @click="
            videoShow = false;
            closeVideo();
          "
          :src="Close"
        />
      </div>
      <div class="grid2 video-box">
        <player
          ref="pushVideoPlayUrl"
          style="height: 50vh"
          :videoUrl="videoRow.pushVideoPlayUrl"
          fluent
          autoplay
          @screenshot="shot"
          @destroy="destroyJessibuca"
        />
        <player
          ref="computingVideoPlayUrl"
          style="height: 50vh; margin-left: 10px"
          :videoUrl="videoRow.computingVideoPlayUrl"
          fluent
          autoplay
          @screenshot="shot"
          @destroy="destroyJessibuca"
        />
      </div>
    </div>
  </div>
  <!-- 图片预览 -->
  <imagePreview
    :isShow="isShowImgPanel"
    :isSign="true"
    :info="imageInfo"
    :list="dataList"
    @onClose="closeImagePanel"
    type="alarm"
  />
</template>
<script setup lang="ts">
import { ref, reactive, onMounted, h } from 'vue';
import { useI18n } from 'vue-i18n';
import Close from '/@/assets/icons/audio/close.png';
import { SmileOutlined, VideoCameraOutlined } from '@ant-design/icons-vue';
import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import {
  getAlgorithmAlarmListPageVo,
  getAlgorithmModelListPageVo,
  flagMisreportByAlgorithmAlarm,
  setAlarmStatus,
  BatchSetAlarmStatus,
} from '/@/api/alarm';
import player from '/@/components/jessibuca.vue';
import { TableState } from 'ant-design-vue/lib/table/interface';
import imagePreview from '/@/components/imagePreview/index.vue';
import { CURRENT_CONFIG as config } from '/@/api/http/config';
import { message, Modal } from 'ant-design-vue';
import { getAlarmId, toCheckPoint } from '/@/api/manage';
import { getAlarmList } from '/@/api/robot-dog';
import { ELocalStorageKey } from '/@/types';
import { joinMediaUrl } from '/@/utils/joinImgUrl';

const { t } = useI18n();

const videoRow = ref({
  pushVideoPlayUrl: '',
  computingVideoPlayUrl: '',
});
const viewMode = ref<'table' | 'card'>('card');
const value3 = ref([]);
const videoShow = ref(false);
const selectedRowKeys = ref<(string | number)[]>([]);
const selectedRows = ref<any[]>([]);
const rowSelection = reactive({
  selectedRowKeys,
  onChange: (keys: (string | number)[], rows: any[]) => {
    selectedRowKeys.value = keys;
    selectedRows.value = rows;
  },
});
const setCellStyle = () => {
  return {
    style: {
      padding: '0 16px',
    },
  };
};
const rowLoading = reactive({});
const dataList = ref([]);
const listLoading = ref(false);
/** 列表内容区固定高度（与 .list-body 一致，预留表头） */
const tableScrollY = 'calc(100vh - 295px)';
const isShowImgPanel = ref(false);
const imageInfo = ref({});
function closeImagePanel() {
  isShowImgPanel.value = false;
  getList();
}
function openImages(record) {
  isShowImgPanel.value = true;
  imageInfo.value = record;
}
const onChange = (value, dateString) => {};
const playVideo = (val) => {
  videoShow.value = true;
  videoRow.value = {
    pushVideoPlayUrl: val.pushVideoPlayUrl,
    computingVideoPlayUrl: val.computingVideoPlayUrl,
  };
};
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId);
const droneSn = localStorage.getItem('drone_sn');
const alarmId = ref('');
const pageData = reactive({
  page_num: 1,
  page_size: 20,
  times: null,
  region_code: Number(localStorage.getItem('map_regin_code')),
  workspace_id: workspaceId,
  marker_status: 1,
  // searchKey: '',
  // modelName: '',
  // modelNo: '',
  // customerName: config.customerNo,
  // misreport: 0
});
const modelList = ref([]);
const allModelNo = ref('');
const paginationProp = reactive({
  showQuickJumper: true,
  showSizeChanger: true,
  page_size: 20,
  current: 1,
  total: 0,
});

onMounted(() => {
  // getAlarm()
  getList();
});
/* function getAlarm () {
  getAlarmId({
    workspace_id: workspaceId,
    drone_sn: droneSn
  }).then(res => {
    if (res.code === 0) {
      alarmId.value = res.data
    }
  })
} */
function flyTo(record) {
  rowLoading[record.id] = true;
  toCheckPoint({
    workspace_id: workspaceId,
    drone_sn: droneSn,
    alarm_id: record.id,
  })
    .then((res) => {
      if (res.code === 0) {
        message.success(t('algorithm.executeSuccess'));
        getList();
        // getAlarm()
      }
    })
    .finally(() => {
      rowLoading[record.id] = false;
    });
}
function onSign() {
  Modal.confirm({
    title: h('div', { style: 'color: var(--uav-text-basic)' }, t('algorithm.markAsFalseAlarmTitle')),
    onOk() {
      BatchSetAlarmStatus({ ids: selectedRowKeys.value, marker_status: 0 }).then((res) => {
        if (res.code === 0) {
          message.success(t('algorithm.markSuccess'));
          selectedRows.value = [];
          selectedRowKeys.value = [];
          getList();
        }
      });
    },
    onCancel() {},
  });
}
function handleMark(record) {
  Modal.confirm({
    title: h('div', { style: 'color: var(--uav-text-basic)' }, t('algorithm.markAsFalseAlarmTitle')),
    onOk() {
      setAlarmStatus({ id: record.id, marker_status: 0 }).then((res) => {
        if (res.code === 0) {
          message.success(t('algorithm.markSuccess'));
          getList();
        }
      });
    },
    onCancel() {},
  });
}
function refreshData(page) {
  pageData.page_num = page.current || 1;
  if (page.pageSize) {
    pageData.page_size = page.pageSize;
  }
  getList();
}
function handlePageChange(page: number, pageSize: number) {
  refreshData({ current: page, pageSize });
}
function changePage() {
  pageData.page_num = 1;
  if (!pageData.model_no) {
    pageData.model_no = allModelNo.value;
  }
  pageData.start_time = pageData?.times?.[0] || '';
  pageData.end_time = pageData?.times?.[1] || '';
  getList();
}
function getList() {
  listLoading.value = true;
  getAlarmList({
    page: pageData.page_num,
    size: pageData.page_size,
    deviceType: 0,
  })
    .then((res) => {
      if (res?.code === 0 && res.data) {
        const d = res.data;
        paginationProp.total = d.pagination?.total ?? d.total ?? 0;
        paginationProp.current = d.pagination?.page ?? pageData.page_num;
        paginationProp.page_size = d.pagination?.size ?? pageData.page_size;
        const list = d.list || [];
        dataList.value = list.map((el) => {
          const modelName = el.label ?? el.modelName;
          const alarmDate = el.createTime ?? el.alarmDate;
          const alarmImage = el.objectKey ? joinMediaUrl(el.objectKey) : el.alarmImage || '';
          return {
            ...el,
            modelName,
            alarmDate,
            alarmImage,
            object_keys: alarmImage,
            lat: el.latitude != null ? String(el.latitude) : '0.0',
            lng: el.longitude != null ? String(el.longitude) : '0.0',
          };
        });
      }
    })
    .finally(() => {
      listLoading.value = false;
    });
}

function closeVideo() {
  videoRow.value = {
    pushVideoPlayUrl: '',
    computingVideoPlayUrl: '',
  };
}
function destroyJessibuca(idx) {
  this.clear(idx);
}
function clear(idx) {
  const dataStr = window.localStorage.getItem('playData') || '[]';
  const data = JSON.parse(dataStr);
  data[idx - 1] = null;
  window.localStorage.setItem('playData', JSON.stringify(data));
}
function shot(e) {
  // send({code:'image',data:e})
  const base64ToBlob = function (code) {
    const parts = code.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], {
      type: contentType,
    });
  };
  const aLink = document.createElement('a');
  const blob = base64ToBlob(e); // new Blob([content]);
  const evt = document.createEvent('HTMLEvents');
  evt.initEvent('click', true, true); // initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
  aLink.download = t('algorithm.screenshotFileName');
  aLink.href = URL.createObjectURL(blob);
  aLink.click();
}
</script>

<style lang="scss" scoped>
.video-box {
  width: 100%;
  margin-top: 10px;
}
.conntiner {
  .searchBox {
    display: flex;
    align-items: center;
    .search-view-switch {
      margin-left: auto;
    }
  }
  .tablebox {
    margin-top: 20px;
    height: calc(100vh - 180px);
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
    .list-body {
      flex: 1;
      min-height: 0;
      height: calc(100vh - 180px - 60px);
      min-height: calc(100vh - 180px - 60px);
      max-height: calc(100vh - 180px - 60px);
      overflow: hidden;
    }
    :deep(.alarm-card-spin) {
      height: 100%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      .ant-spin-nested-loading,
      .ant-spin-container {
        height: 100%;
        min-height: 100%;
        display: flex;
        flex-direction: column;
      }
      &.ant-spin-nested-loading > div > .ant-spin {
        max-height: none;
      }
      .ant-spin-text {
        color: $text-main;
        text-shadow: none;
      }
    }
    .task-card-grid {
      display: grid;
      grid-template-columns: repeat(6, minmax(0, 1fr));
      gap: 12px;
      height: 100%;
      min-height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding-top: 6px;
      padding-right: 4px;
    }
    .empty-state {
      grid-column: 1 / -1;
      min-height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .table-scroll {
      height: 100%;
      min-height: 100%;
      overflow: hidden;
      :deep(.ant-table-body) {
        min-height: calc(100vh - 295px);
        overflow-y: auto !important;
      }
    }
    .task-card {
      position: relative;
      border-radius: 16px;
      border: 1px solid rgba(255, 255, 255, 0.18);
      background: rgba(35, 35, 40, 0.6);
      backdrop-filter: blur(28px) saturate(150%);
      -webkit-backdrop-filter: blur(28px) saturate(150%);
      box-shadow:
        inset 1px 1px 0 rgba(255, 255, 255, 0.15),
        inset -1px -1px 0 rgba(0, 0, 0, 0.3),
        0 8px 32px rgba(0, 0, 0, 0.6),
        0 2px 8px rgba(0, 0, 0, 0.4);
      padding: 18px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
        pointer-events: none;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.08) 0%,
          rgba(255, 255, 255, 0.02) 40%,
          transparent 60%
        );
      }
      &:hover {
        transform: translateY(-4px);
        background: rgba(45, 45, 50, 0.85);
        border-color: rgba(0, 113, 227, 0.45);
        box-shadow:
          inset 1px 1px 0 rgba(255, 255, 255, 0.22),
          inset -1px -1px 0 rgba(0, 0, 0, 0.3),
          0 0 0 1px rgba(0, 113, 227, 0.18),
          0 -16px 50px rgba(0, 113, 227, 0.15),
          0 20px 60px rgba(0, 113, 227, 0.18),
          0 12px 30px rgba(0, 0, 0, 0.6);
      }
    }
    .task-info {
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .task-meta-row {
      margin: 0;
      display: flex;
      align-items: center;
      color: var(--uav-text-basic);
    }
    .task-meta-label {
      flex-shrink: 0;
      color: rgba(255, 255, 255, 0.42);
    }
    .task-meta-value {
      min-width: 0;
      color: rgba(255, 255, 255, 0.82);
      word-break: break-all;
    }
    .alarm-image-wrap {
      width: 100%;
      height: 160px;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      background: var(--uav-bg-2);
    }
    .alarm-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .pagination-wrapper {
      margin-top: 12px;
      display: flex;
      justify-content: flex-end;
      flex-shrink: 0;
    }
  }
  .flying {
    background-color: $color-warning;
    color: $text-primary;
    &:hover {
      background-color: $color-warning;
    }
  }
  .vediobox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70%;
    min-height: 523px;
    background: $bg-interactive;
    padding: 23px 25px 35px 20px;
    box-sizing: border-box;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: $text-primary;
      position: relative;
      img {
        position: absolute;
        width: 21px;
        height: 21px;
        right: 0;
        top: 0;
      }
    }
    .video {
      margin-top: 18px;
      width: 805px;
      height: 430px;
      #videobox {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 1800px) {
  .conntiner .tablebox .task-card-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (max-width: 1600px) {
  .conntiner .tablebox .task-card-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (max-width: 1366px) {
  .conntiner .tablebox .task-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {
  .conntiner .tablebox .task-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .conntiner .tablebox .task-card-grid {
    grid-template-columns: 1fr;
  }
}
</style>
